import React from "react";

export const EditIcon = (props) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        className={props.className}
        width="10"
        height="11"
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5856 0.101562L9.60227 2.30156L8.06489 3.97943L6.04823 1.77943L7.5856 0.101562ZM0.199219 10.3594H2.21589L7.11437 5.01563L5.0977 2.81563L0.199219 8.15943V10.3594Z"
          fill="#1E1D1D"
          style={{
            fill: "#1E1D1D",
            fill: "color(display-p3 0.1176 0.1137 0.1137)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
